type Data = {
  Sigla: string;
  Nome: string;
  Id: number | string;
  sigla: string;
  id_uf: number;
  nm_sexo: string;
  id_sexo: number;
  nm_orgaoexpedidor: string;
  id_oe: number;
  nm_estado_civil: string;
  id_estado_civil: number;
  nm_escolaridade: string;
  id_escolaridade: number;
  tx_escolaridade: string;
  cd_escolaridade: number;
  nm_grau_parentesco: string;
  nm_siglagraupar: string;
  id_parentesco: number;
  cd_parentesco: number;
  id_orgao: number;
  tx_nm_orgao: string;
  Descricao: string;
  id_perfil: number;
  tx_perfil: string;
  id_fontepag: number;
  tx_nm_fonte_pag: string;
  nm_nm_contrato_s4_e: string;
  id_meiopagto_if: number;
  nm_prodcomerc: string;
  id_prodcomerc: number;
};

export const changeUF = (ufs: Data[]): void => {
  ufs.map(data => {
    data.Nome = data.sigla;
    data.Id = data.id_uf;
  });
};
export const changeUFSigla = (ufs: Data[]): void => {
  ufs.map(data => {
    data.Nome = data.sigla;
    data.Id = data.sigla;
  });
};
export const changeGender = (genders: Data[]): void => {
  genders.map(data => {
    data.Nome = data.nm_sexo;
    data.Id = data.id_sexo;
  });
};
export const changeIssuingAgency = (issuingAgencies: Data[]): void => {
  issuingAgencies.map(data => {
    data.Nome = data.nm_orgaoexpedidor;
    data.Id = data.id_oe;
  });
};
export const changePerfil = (perfis: Data[]): void => {
  perfis.map(data => {
    data.Nome = data.tx_perfil;
    data.Id = data.id_perfil;
  });
};
export const changeFontePagamento = (perfis: Data[]): void => {
  perfis.map(data => {
    data.Nome = data.tx_nm_fonte_pag;
    data.Id = data.id_fontepag;
  });
};
export const changePagamento = (perfis: Data[]): void => {
  perfis.map(data => {
    data.Nome = data.nm_nm_contrato_s4_e;
    data.Id = data.id_meiopagto_if;
  });
};
export const changeCivilStatus = (civilStatus: Data[]): void => {
  civilStatus.map(data => {
    data.Nome = data.nm_estado_civil;
    data.Id = data.id_estado_civil;
  });
};
export const changeSchooling = (schooling: Data[] = []): Data[] => {
  return schooling.map(data => {
    data.Nome =
      data.nm_escolaridade || data.tx_escolaridade || data.Descricao || '';
    data.Id = data.id_escolaridade || data.cd_escolaridade || data.Id;
    return data;
  });
};

const normalizeParentageName = (value: unknown): string =>
  String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, ' ')
    .trim();

const ILHA_BELA_ONLY_PARENTAGES = new Set([
  'AVOS',
  'TIOS',
  'SOBRINHOS',
  'BISAVOS',
  'BISNETOS',
  'GENRO',
  'NORA',
  'PADRASTO',
  'MADRASTA',
  'CUNHADOS',
  'AVOS DO CONJUGE',
  'NETOS DO CONJUGE',
]);

export const changeParentage = (parentage: Data[] = []): Data[] => {
  return parentage
    .filter(data => {
      const name = normalizeParentageName(
        data.nm_siglagraupar || data.nm_grau_parentesco,
      );
      return !ILHA_BELA_ONLY_PARENTAGES.has(name);
    })
    .map(data => {
      data.Sigla = data.nm_siglagraupar;
      data.Id = data.id_parentesco;
      return data;
    });
};

const ILHA_BELA_PARENTAGES = [
  { label: 'Pais', group: 'Por consanguinidade', aliases: ['PAI', 'PAIS'] },
  { label: 'Mães', group: 'Por consanguinidade', aliases: ['MAE', 'MAES'] },
  {
    label: 'Filhos',
    group: 'Por consanguinidade',
    aliases: ['FILHO', 'FILHOS', 'FILHA', 'FILHAS'],
  },
  {
    label: 'Irmãos',
    group: 'Por consanguinidade',
    aliases: ['IRMAO', 'IRMAOS', 'IRMA', 'IRMAS'],
  },
  { label: 'Avós', group: 'Por consanguinidade', aliases: ['AVO', 'AVOS'] },
  {
    label: 'Netos',
    group: 'Por consanguinidade',
    aliases: ['NETO', 'NETOS', 'NETA', 'NETAS'],
  },
  {
    label: 'Tios',
    group: 'Por consanguinidade',
    aliases: ['TIO', 'TIOS', 'TIA', 'TIAS'],
  },
  {
    label: 'Sobrinhos',
    group: 'Por consanguinidade',
    aliases: ['SOBRINHO', 'SOBRINHOS', 'SOBRINHA', 'SOBRINHAS'],
  },
  {
    label: 'Bisavós',
    group: 'Por consanguinidade',
    aliases: ['BISAVO', 'BISAVOS'],
  },
  {
    label: 'Bisnetos',
    group: 'Por consanguinidade',
    aliases: ['BISNETO', 'BISNETOS', 'BISNETA', 'BISNETAS'],
  },
  {
    label: 'Cônjuge/Companheiro',
    group: 'Por afinidade',
    aliases: ['CONJUGE', 'CONJUGE COMPANHEIRO', 'COMPANHEIRO', 'COMPANHEIRA'],
  },
  {
    label: 'Sogros',
    group: 'Por afinidade',
    aliases: ['SOGRO', 'SOGROS', 'SOGRA', 'SOGRAS'],
  },
  { label: 'Genro', group: 'Por afinidade', aliases: ['GENRO'] },
  { label: 'Nora', group: 'Por afinidade', aliases: ['NORA'] },
  { label: 'Padrasto', group: 'Por afinidade', aliases: ['PADRASTO'] },
  { label: 'Madrasta', group: 'Por afinidade', aliases: ['MADRASTA'] },
  {
    label: 'Enteados',
    group: 'Por afinidade',
    aliases: ['ENTEADO', 'ENTEADOS', 'ENTEADA', 'ENTEADAS'],
  },
  {
    label: 'Cunhados',
    group: 'Por afinidade',
    aliases: ['CUNHADO', 'CUNHADOS', 'CUNHADA', 'CUNHADAS'],
  },
  {
    label: 'Avós do cônjuge',
    group: 'Por afinidade',
    aliases: ['AVO DO CONJUGE', 'AVOS DO CONJUGE'],
  },
  {
    label: 'Netos do cônjuge',
    group: 'Por afinidade',
    aliases: ['NETO DO CONJUGE', 'NETOS DO CONJUGE'],
  },
  {
    label: 'Titular',
    group: 'Parentescos existentes',
    aliases: ['TITULAR'],
  },
  {
    label: 'Menor sob guarda legal',
    group: 'Parentescos existentes',
    aliases: ['MENOR SOB GUARDA LEGAL'],
  },
  {
    label: 'Outros',
    group: 'Parentescos existentes',
    aliases: ['OUTRO', 'OUTROS'],
  },
];

export const changeParentageIlhaBela = (parentage: Data[] = []): Data[] => {
  const options = parentage.map(data => ({
    ...data,
    Id: data.id_parentesco,
    Sigla: data.nm_siglagraupar || data.nm_grau_parentesco,
  }));
  const getOptionName = (option: Data): string =>
    normalizeParentageName(option.nm_siglagraupar || option.nm_grau_parentesco);
  const matchesAlias = (name: string, alias: string): boolean =>
    name === alias || ` ${name} `.includes(` ${alias} `);
  const findMatchingOption = (aliases: string[]): Data | undefined => {
    const normalizedAliases = aliases.map(normalizeParentageName);
    const exactMatch = options.find(option =>
      normalizedAliases.includes(getOptionName(option)),
    );

    if (exactMatch) {
      return exactMatch;
    }

    return options
      .map(option => ({
        option,
        matchLength: normalizedAliases.reduce(
          (length, alias) =>
            matchesAlias(getOptionName(option), alias)
              ? Math.max(length, alias.length)
              : length,
          0,
        ),
      }))
      .filter(({ matchLength }) => matchLength > 0)
      .sort((a, b) => b.matchLength - a.matchLength)[0]?.option;
  };
  const otherOption =
    options.find(option => getOptionName(option).includes('OUTRO')) ||
    ({} as Data);

  return ILHA_BELA_PARENTAGES.map(parentageOption => {
    const option = findMatchingOption(parentageOption.aliases) || otherOption;

    return {
      ...option,
      Id: option.id_parentesco ?? option.Id ?? 14,
      Nome: parentageOption.label,
      Sigla: parentageOption.label,
      group: parentageOption.group,
    };
  });
};
export const changesubjects = (subject: Data[]): void => {
  subject.map(data => {
    data.Sigla = data.Descricao;
  });
};
export const changeParentageGDF = (parentage: Data[]): Data[] => {
  const returnData = parentage
    .filter(
      data =>
        data.id_parentesco == 10 ||
        data.id_parentesco == 11 ||
        data.id_parentesco == 14,
    )
    .map(data => {
      return {
        ...data,
        Sigla: data.id_parentesco == 14 ? 'DEPENDENTE' : data.nm_siglagraupar,
        Id: data.id_parentesco,
      };
    });
  return returnData;
};

export const changeOrgao = (orgao: Data[]): Data[] => {
  const returnData = orgao
    .filter(
      data =>
        data.id_orgao !== 93 && data.id_orgao !== 54 && data.id_orgao !== 57,
    )
    .map(data => {
      return {
        ...data,
        Nome: data.tx_nm_orgao,
        Id: data.id_orgao,
      };
    });
  return returnData;
};

export const changeProdutos = (produtos: Data[]): void => {
  produtos.map(data => {
    data.Nome = `${data.id_prodcomerc} - ${data.nm_prodcomerc}`;
    data.Id = data.id_prodcomerc;
  });
};
